import { db } from './matudb';

export function getStorage() {
  return {};
}

export function ref(_storage, path) {
  return { fullPath: String(path || '').replace(/^\/+/, '') };
}

export async function uploadBytes(storageRef, file) {
  const { error } = await db.storage.upload(storageRef.fullPath, file);
  if (error) throw new Error(error.message || 'No se pudo subir el archivo');
  return { ref: storageRef };
}

export function uploadBytesResumable(storageRef, file) {
  const task = {
    snapshot: { ref: storageRef },
    on(_event, onProgress, onError, onComplete) {
      uploadBytes(storageRef, file)
        .then(() => {
          if (onProgress) {
            const total = file?.size || 1;
            onProgress({ bytesTransferred: total, totalBytes: total });
          }
          if (onComplete) onComplete();
        })
        .catch((error) => {
          if (onError) onError(error);
        });
      return () => {};
    },
  };
  return task;
}

export async function getDownloadURL(storageRef) {
  return db.storage.getPublicUrl(storageRef.fullPath).data.publicUrl;
}
